<template>
  <div>
    <b-card title="Create Stock in">
      <div class="d-flex justify-content-center mt-4 mb-2">
        <h2>Choose Items</h2>
      </div>

      <b-table-simple responsive class="no-scroll-table">
        <b-thead>
          <b-tr>
            <b-th>Item</b-th>
            <b-th>Warehouse</b-th>
            <b-th>Batch</b-th>
            <b-th>Exp Date</b-th>
            <b-th>Quantity</b-th>
            <b-th> Price</b-th>
            <b-th>Actions</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in stocks" :key="index">
            <b-td>
              <AutoComplete
                class="mt-1"
                style="width: 14rem"
                placeholder="Select Item"
                v-model="stocks[index].item_id"
                param-query="search"
                :serializer="(val) => val.id"
                endpoint="item"
                text-title="name"
            /></b-td>
            <b-td>
              <AutoComplete
                class="mt-1"
                style="width: 14rem"
                placeholder="Select Warehouse"
                v-model="stocks[index].warehouse_id"
                param-query="search"
                :serializer="(val) => val.id"
                endpoint="warehouse"
                text-title="name"
              />
            </b-td>
            <b-td>
              <b-form-input
                style="width: 5rem"
                v-model="stocks[index].batch_no"
              ></b-form-input>
            </b-td>

            <b-td>
              <datepicker
                v-model="stocks[index].expiry_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                style="width: 10rem"
                class="datebtn2"
                :disabled-dates="{
                  to: new Date(new Date().setDate(new Date().getDate() - 1)),
                }"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-td>
            <b-td>
              <b-form-input
                type="number"
                v-model="stocks[index].quantity"
              ></b-form-input>
            </b-td>
            <b-td>
              <b-form-input
                type="number"
                :max="50000"
                v-model="stocks[index].unit_price"
              ></b-form-input>
            </b-td>
            <b-td>
              <div class="d-flex align-items-end">
                <b-button
                  class="mx-1"
                  variant="primary"
                  size="sm"
                  @click="addItem"
                  >+</b-button
                >
                <b-button
                  :disabled="index === 0"
                  size="sm"
                  variant="danger"
                  @click="removeItem(index)"
                  >X</b-button
                >
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <hr />
      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="submitItem">
          Create Stock
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BBadge,
  BTableSimple,
  BTbody,
  BThead,
  BTr,
  BTd,
  BTh,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    BTableSimple,
    BTbody,
    BThead,
    BTr,
    BTd,
    BTh,
    BCard,
    BBadge,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      balanceId: '',
      currentBalance: {},
      categoryId: null,
      stocks: [
        {
          item_id: '',
          warehouse_id: '',
          quantity: '',
          batch_no: '',
          unit_price: 0,
          expiry_date: '',
        },
      ],
      data: [],
      params: {
        form: {},
        path: '',
      },

      page: 1,
    };
  },

  computed: {},

  methods: {
    addItem() {
      this.stocks.push({
        quantity: '',
        batch_no: '',
        unit_price: 0,
        expiry_date: '',
      });
    },
    removeItem(index) {
      if (index === 0) return;
      this.stocks.splice(index, 1);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1); // getMonth() is zero-based
      let day = '' + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    submitItem() {
      this.stocks = this.stocks.map((stock) => ({
        ...stock,
        expiry_date: this.formatExpDate(stock.expiry_date),
      }));

      (this.params.form = { stockins: this.stocks }),
        (this.params.path = `/stockin`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.$router.push({ name: 'stockin' });

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Created',
                variant: 'success',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
